"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useCancellablePromise;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _react = _interopRequireWildcard(require("react"));

function makeCancelable(promise) {
  var isCanceled = false;
  var wrappedPromise = new Promise(function (resolve, reject) {
    promise.then(function (val) {
      return isCanceled ? reject(new Error('Canceled')) : resolve(val);
    }).catch(function (error) {
      return isCanceled ? reject(new Error('Canceled')) : reject(error);
    });
  });
  return {
    promise: wrappedPromise,
    cancel: function cancel() {
      isCanceled = true;
    }
  };
}

function ensurePromise(_x) {
  return _ensurePromise.apply(this, arguments);
}

function _ensurePromise() {
  _ensurePromise = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(p) {
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", p);

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _ensurePromise.apply(this, arguments);
}

function useCancellablePromise() {
  var cancelable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : makeCancelable;

  // test if the input argument is a cancelable promise generator
  if (cancelable(Promise.resolve(true)).cancel === undefined) {
    throw new Error('promise wrapper argument must provide a cancel() function');
  }

  var promises = (0, _react.useRef)([]);
  (0, _react.useEffect)(function () {
    promises.current = [];
    return function () {
      promises.current.forEach(function (p) {
        return p.cancel();
      });
      promises.current = [];
    };
  }, []);
  var cancellablePromise = (0, _react.useCallback)(function (p) {
    var cPromise = cancelable(ensurePromise(p));
    promises.current.push(cPromise);

    cPromise.promise.cancel = function () {
      cPromise.cancel();
    };

    return cPromise.promise;
  }, [cancelable]);
  return cancellablePromise;
}

useCancellablePromise.makeCancelable = makeCancelable;